export const translateExperiencias = {
  pt: [
    {
      id: 1,
      empresa: "Codie Tecnologia",
      cargo: "Estagiário Desenvolvedor Back-end",
      periodo: "09/2025 — Presente",
      descricao: "Atuação no desenvolvimento e manutenção de aplicações back-end e criação de APIs REST utilizando C# e .NET, estruturando módulos de software com padrões de repositório, mapeamento de DTOs e manipulação de dados em JSON, além do gerenciamento de banco de dados via SQL e controle de versionamento.",
      icone: "IconeCodie" // Substitua pelo nome do seu componente ou caminho do ícone
    },
    {
      id: 2,
      empresa: "Monkey Tabacaria",
      cargo: "Administração, Compras e Logística",
      periodo: "09/2021 — 02/2024",
      descricao: "Evolução profissional passando pelas áreas de estoque, administração e compras. Responsável pela negociação com fornecedores focada em otimização de custos, gestão da entrada de mercadorias, emissão de notas fiscais e controle de inventários. Atuação no gerenciamento do e-commerce e suporte direto à gerência de 4 filiais (distribuídas em 2 estados), prestando apoio operacional e assumindo a gestão das lojas na ausência dos gerentes titulares.",
      icone: "IconeMonkey"
    },
    {
      id: 3,
      empresa: "Clique Gráfica",
      cargo: "Atendente / Designer Gráfico",
      periodo: "02/2020 — 09/2021",
      descricao: "Criação de artes sob medida para atender às necessidades dos clientes, atendimento direto ao público fornecendo orçamentos e garantindo a satisfação. Auxiliei também no desenvolvimento e acabamento dos materiais gráficos impressos.",
      icone: "IconeGrafica"
    }
  ],
  
  en: [
    {
      id: 1,
      empresa: "Codie Tecnologia",
      cargo: "Back-end Developer Intern",
      periodo: "09/2025 — Present",
      descricao: "Development and maintenance of back-end applications and REST APIs creation using C# and .NET, structuring software modules with repository patterns, DTO mapping, and JSON data manipulation, in addition to database management via SQL and version control.",
      icone: "IconeCodie"
    },
    {
      id: 2,
      empresa: "Monkey Tabacaria",
      cargo: "Administration, Purchasing, and Logistics",
      periodo: "09/2021 — 02/2024",
      descricao: "Professional evolution through the inventory, administration, and purchasing departments. Responsible for supplier negotiation focused on cost optimization, goods receipt management, invoice issuance, and inventory control. Managed the e-commerce platform and provided direct support to the management of 4 branches (distributed across 2 states), offering operational support and taking over store management in the absence of the head managers.",
      icone: "IconeMonkey"
    },
    {
      id: 3,
      empresa: "Clique Gráfica",
      cargo: "Customer Service / Graphic Designer",
      periodo: "02/2020 — 09/2021",
      descricao: "Creation of custom artwork to meet client needs, direct customer service providing quotes and ensuring satisfaction. Also assisted in the development and finishing of printed graphic materials.",
      icone: "IconeGrafica"
    }
  ]
};